/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { pluginPostbackRequestSchema } from "./pluginPostbackRequestSchema.ts";

export const callbackPluginCreateStatus200Schema = z.any();

export const callbackPluginCreateResponseSchema = callbackPluginCreateStatus200Schema;

export const callbackPluginCreateDataSchemaJson = pluginPostbackRequestSchema;

export const callbackPluginCreateDataSchemaXml = pluginPostbackRequestSchema;

export const callbackPluginCreateDataSchema = z.union([callbackPluginCreateDataSchemaJson, callbackPluginCreateDataSchemaXml]);
